import React from "react";
import styled from "styled-components";
import { ClickAwayListener, Drawer } from "@mui/material";

interface IDockedSidebar {
    sidebar: () => JSX.Element | null;
    content: () => JSX.Element;
    open: boolean;
    onClose: () => void;
    sidebarWidth: number;
    toogleIcon?: () => JSX.Element;
}

export function DockedSidebar(props: IDockedSidebar) {
    return (
        <Wrapper>
            <ContentWrapper
                open={props.open}
                sidebarWidth={props.sidebarWidth}
            >
                {props.content()}
            </ContentWrapper>
            {props.toogleIcon && (
                <StyledOpenButton data-testid={`editconfig-btn-toggle`}>{props.toogleIcon()}</StyledOpenButton>
            )}
            <ClickAwayListener
                onClickAway={() => {
                    if (props.open) {
                        props.onClose();
                    }
                }}
                mouseEvent="onMouseDown"
            >
                <StyledDrawer
                    open={props.open}
                    variant="persistent"
                    anchor="right"
                    onClose={props.onClose}
                    width={props.sidebarWidth}
                    data-testid={`editconfig-${props.open ? "open" : "close"}`}
                >
                    <StyledSidebarContent>
                        {props.sidebar()}
                        {props.toogleIcon && (
                            <StyledCloseButton open={props.open}>{props.toogleIcon()}</StyledCloseButton>
                        )}
                    </StyledSidebarContent>
                </StyledDrawer>
            </ClickAwayListener>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    display: flex;
    flex: 1;
    overflow: hidden;
    height: 100%;
`;

const ContentWrapper = styled.div<{ sidebarWidth: number; open: boolean }>`
    width: ${(props) => (props.open ? `calc(100% - ${props.sidebarWidth}px)` : "100%")};
    height: 100%;
    overflow: auto;
`;

const StyledDrawer = styled(Drawer)<{ width: number }>`
    && {
        .MuiDrawer-paper {
            width: ${(props) => props.width}px;
            position: absolute;
            overflow: visible;
        }
    }
`;

const StyledOpenButton = styled.div`
    position: absolute;
    top: 20px;
    right: 0;
`;

const StyledCloseButton = styled.div<{ open: boolean }>`
    position: absolute;
    top: 20px;
    left: -40px;
    visibility: ${(props) => (props.open ? "visible" : "hidden")};
`;

const StyledSidebarContent = styled.div`
    position: relative;
    overflow: auto;
    width: 100%;
    height: 100%;
`;
